<template>
  <div class="kye-report-dgkp002" :class="{'kye-report-selected': selected}" @click="handleClick('cardClick')">
    <div class="dgkp002_main-left">
      <img
        class="dgkp002_main-icon1"
        :src="data.mainIcon1 || mainIcon1"
        @click="handleClick('mainIcon1')"
        v-events="{ eventsMap, ignoreEventName, args: ['mainIcon1', data.mainIcon1]}"
      />
      <div class="dgkp002_main-cell-center">
        <div class="dgkp002_main-cell-title">
          <div
            @click="handleClick('mainTitle')"
            v-events="{ eventsMap, ignoreEventName, args: ['mainTitle', data.mainTitle]}"
          >{{ data.mainTitle }}</div>
          <KyeReportCardQuestion
            class="dgkp002_main-icon2"
            :icon="data.mainIcon2"
            :popover="data.popover"
            @click="handleClick('mainIcon2')">
            <slot :name="'tooltip'"></slot>
          </KyeReportCardQuestion>
        </div>
        <div class="dgkp002_main-cell-index" @click="handleClick('mainIndex')">
          <div
            class="dgkp002_main-index"
            v-events="{ eventsMap, args: ['mainIndex', data.mainIndex]}"
          >{{ data.mainIndex }}</div>
          <div
            class="dgkp002_main-index-unit"
            v-events="{ eventsMap, args: ['mainIndexUnit', data.mainIndexUnit]}"
          >{{ data.mainIndexUnit }}</div>
        </div>
      </div>
    </div>
    <div class="dgkp002_cell-list">
      <div
        class="dgkp002_list-cell"
        v-for="(item, index) in data.list"
        :key="index"
        >
          <div
            class="dgkp002_list-title"
            @click="handleClick('listTitle', index)"
            v-events="{ eventsMap, ignoreEventName, args: ['listTitle', index, item.listTitle]}"
          >{{ item.listTitle }}</div>
          <div
            class="dgkp002_list-index"
            v-events="{ eventsMap, ignoreEventName, args: ['listIndex', index, item.listIndex]}"
            @click="handleClick('listIndex', index)"
          >{{ item.listIndex }}</div>
          <kyeReportCardArrow
            @click="handleClick('listIcon', index)"
            class="dgkp002_list-icon"
            :type="item.listIcon"
            v-events="{ eventsMap, ignoreEventName, args: ['listIcon', index, item.listIcon]}"
          ></kyeReportCardArrow>
      </div>
    </div>
    <card-popover
      :popoverConfig="popoverConfig"
    >
      <slot :name="cardPopoverSlotName"></slot>
    </card-popover>
  </div>
</template>
<script>
import mainIcon1 from '../../asset/images/dgkp002.png'
import KyeReportCardQuestion from '../common/question.vue'
import kyeReportCardArrow from '../common/arrow.vue'
export default {
  name: 'KyeReportDgkp002',
  components: {
    KyeReportCardQuestion,
    kyeReportCardArrow
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mainIcon1
    }
  },
  mounted() {
  },
  methods: {
    handleClick(eventName, index) {
      if (Number(index) >= 0) {
        this.$emit(eventName, index, this.data)
      } else {
        this.$emit(eventName, this.data)
      }
    }
  }
}
</script>
<style lang="scss">
@import '../../style/extend.scss';
.kye-report-dgkp002 {
  background: #FFFFFF;
  border-radius: 4px;
  padding: 16px 18px;
  flex-direction: row;
  align-items: center;
  width: 310px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  .dgkp002_main-icon1 {
    width: 32px;
    height: 32px;
  }
  .dgkp002_main-left {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .dgkp002_main-cell-center {
    margin-left: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .dgkp002_main-cell-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: #666666;
      font-size: 12px;
      line-height: 14px;
      gap: 4px;
    }
    .dgkp002_main-cell-index {
      color: #333333;
      font-size: 20px;
      line-height: 20px;
      font-weight: 600;
      display: flex;
      flex-direction: row;
      margin-top: 8px;
      .dgkp002_main-index-unit {
        display: flex;
        flex-direction: column-reverse;
        margin-left: 2px;
        font-size: 12px;
        line-height: 12px;
      }
    }
  }
  .dgkp002_cell-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    color: #666666;
    font-size: 12px;
    .dgkp002_list-cell {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      background: rgba(206, 206, 206, 0.1);
      border-radius: 4px;
      padding: 2px 8px;
      .dgkp002_list-index {
        margin-left: 8px;
        color:#333333;
        font-weight: 600;
        flex: 1;
        text-align: right;
      }
      .dgkp002_list-icon {
        margin-left: 2px;
      }
    }
  }
}
.kye-report-selected {
  border: 1px solid var(--g-color-primary);
  background: #F8F5FF;
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/card/dgkp002/index.vue